import { createSelector } from "@ngrx/store";
import { AppState } from "..";

const featureSelector = (state: AppState) => state.errorUpdate;

export const selectError = createSelector(
    featureSelector,
    (state) => state.error
);

export const selectErrorIsArchived = createSelector(
    selectError,
    (error) => error?.status === "Archived"
);
